"use client";

import Link from "next/link";
import HeaderOfficialControls from "../../ui/navigation/HeaderOfficialControls";
import "./HeaderOfficial.css";

type HeaderOfficialProps = {
  type?: "default" | "alternate" | "minimal";
};

const HeaderOfficial = ({ type = "default" }: HeaderOfficialProps) => {
  const layoutClass = `official-header-layout ${type}`;

  // فقط در default نشان بده؛ در alternate/minimal اصلاً برند رندر نشه
  const showBrand = type === "default";

  return (
    <header className={layoutClass}>
      
      {type !== "minimal" && <HeaderOfficialControls />}

      {showBrand && (
        <div className={`official-logo-container ${type}`}>
          <Link href="/" aria-label="Home">
            <img
              src="/images/logo/LogoWide.png"
              alt="TownLIT Logo"
              className="official-header-logo-2"
            />
          </Link>
        </div>
      )}

    </header>
  );
};

export default HeaderOfficial;
